module.exports = {
  components: {
    app: {
      header: {
        title: "منشور البرز",
        register: "ثبت نام",
        users: "کاربران",
        login: "ورود",
        logout: "خروج",
        home: "خانه",
        inquiry: "استعلام",
        guid: "راهنما",
        about_us: "درباره ی ما",
        dashboard: "داشبورد",
        createCert: "سفارش مدرک جدید",
        admin: "ادمین پنل",
        contact_us: "تماس با ما",
        profile: "پروفایل",
        about_determining: "درباره ی تعیین سطح",
        what_determining: "همسطح سازی چیست؟",
        application_certificate: "کاربرد گواهی نامه معادل",
        condition: "شرایط صدور گواهی",
      },
      snackbar: {
        close: "بستن",
      },
      page_not_found: {
        title: "404",
        subtitle_part_one: "Sorry!",
        subtitle_part_two: "صفحه ای یافت نشد",
        buttons: {
          go_back: "باز گشت",
        },
      },
    },
    dashboard: {},
  },
  router: {},
  views: {},
  attribute: {},
  validations: {
    required: "{attribute} الزامی است.",
    minLength: "{attribute} باید {min} یا بیشتر از {min} باشد",
    numeric: "{attribute} باید فقط شامل اعداد انگلیسی باشد.",
    sameAsPassword: "{attribute} باید مشابه پسورد باشد.",
    phone_number: "فرمت {attribute} صحیح نیست.",
  },

  FAILED_VALIDATION: "Validation for this particular item failed",
  ACCESS_DENIED: "You are not allowed to do the current action",
  INVALID_GRANT: "Username / password or access token is wrong",
  LOGIN_SUCCESS: "با موفقیت وارد شدید",
  UNAUTHORIZED: "UNAUTHORIZED",
  INVALID_OTP: "Wrong OTP was provided",
  INVALID_PAYLOAD: "Provided payload is invalid",
  INVALID_QUERY: "The requested query parameters can not be used",
  REQUESTS_EXCEEDED: "Hit rate limit; Too many requests",
  ROUTE_NOT_FOUND: "Endpoint does not exist",
  SERVICE_UNAVAILABLE: "Could not use external service",
  FETCH_DATA_FAILED: "Could not fetch data.",
  CREATE_SUCCESS: "با موفقیت ساخته شد.",
  CREATE_FAILED: "Did not create.",
  UPDATE_SUCCESS: "با موفقیت بروزرسانی شد.",
  UPDATE_FAILED: "Did not update.",
  DELETE_SUCCESS: "Deleted successfully.",
  DELETE_FAILED: "Did not delete.",
  ADD_SUCCESS: "با موفقیت اضافه شد.",
  SEND_CODE_SUCCESS: "کد تایید به شماره شما ارسال گردید",
  PASSWORD_CHANGE_SUCCESS: "کلمه ی عبور با موفقیت تغییر یافت",
};
